import { DsCampaignUserGroupInterface } from '../interfaces/ds-campaign-user-group.interface';

/**
 * Class representing a user group and the campaignId linked to it
 */
export class DsCampaignUserGroup {
  /**
   * Id of user group
   */
  id: number;

  campaignId: number;

  /**
   * Creates an instance of DsCampaignUserGroup.
   *
   * @param jsonData the json data
   */
  constructor(jsonData: DsCampaignUserGroupInterface) {
    this.id = jsonData.group_id;
    this.campaignId = jsonData.campaign_id;
  }
}
